<!-- Show alert only if both invoices and payment_history are empty -->
<div v-if="!invoices.length && !payment_history.length" class="alert alert-info text-xxs mt-3">
  <i class="bi bi-info-circle-fill me-2"></i>
  Please wait for your application to be processed
</div>

<!-- Only show the tab card if there is data -->
<div v-else class="card card-nav-tabs rounded-lg border-0 mt-3">
  <p class="mb-1">Generated quotation</p>
  <div class="card-header card-header-primary shadow-2 rounded-lg d-none">
    <div class="nav-tabs-navigation">
      <div class="nav-tabs-wrapper">
        <ul class="nav nav-tabs" data-tabs="tabs">
          <li
            class="nav-item"
            v-for="(tab, index) in tabs"
            :key="index"
            :class="[active_tab === tab ? 'active' : '']"
            @click="set_active_tab(tab)"
          >
            <a
              class="text-white text-decoration-none text-x nav-link text-xxs"
            >
              {{ tab }}
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>

  <div class="card-body mt-0">
    <!-- Invoices Tab -->
    <div v-if="active_tab === 'Invoices'">
      <div class="d-flex justify-content-end align-items-center mb-3"></div>
          <GlobalTable
            v-if="invoices.length"
            :headers="['Id', 'Quote Number', 'Date Issued', 'Date Valid Until', 'Date Created', 'Status', 'Balance']"
            :fields="['id', 'quote_number', 'date_issued', 'date_valid_until', 'date_created', 'status', 'balance']"
            :data="invoices"
            table_id="invoice"
          >

          <template #actions="{ row }">
            <button
              class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
              data-bs-toggle="modal"
              data-bs-target="#preview_invoice"
              @click="open_preview_quote(row.id)"
              >
                Preview
            </button>
            <button class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark" data-bs-toggle="modal" data-bs-target="#invoice_payment">
              Pay Now
            </button>

            <button
              class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
              data-bs-toggle="modal"
              data-bs-target="#reject_quote_modal"
              @click="open_reject_modal(row.id)"
            >
              Reject
            </button>
          </template>
        </GlobalTable>
      </div>

    <!-- Payment History Tab -->
    <div v-if="active_tab === 'Payment history'" class="d-none">
      <div class="card border-0 shadow-sm p-4 border-info bg-light">
        <GlobalTable
          v-if="payment_history.length"
          :headers="['Payment Date', 'Amount', 'Reference']"
          :data="payment_history"
          table_id="payment_history"
        />
        <p v-else class="text-muted text-xxs">No payment history available.</p>
      </div>
    </div>
  </div>
</div>



<!--Make payment modal-->
<teleport to="body">
<div class="modal fade" id="invoice_payment" tabindex="-1" aria-labelledby="invoice_payment_label" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
          <div class="modal-header border-bottom-0 cute-header shadow-lg">
              <p class="modal-title text-white text-xxs" id="invoice_payment_label">Upload proof of payment</p>
              <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
           <div class="modal-body">
                <div class="modal-form-group form-group mb-3 d-flex flex-column mt-2">
                  <label for="invoice_payment" class="modal-form-label form-label text-start text-xxs">Proof of payment:</label>
                  <input class="form-control text-xxs" type="file" id="template_file" @change="handle_file_selection"/>
                </div>
                <div v-if="preview_url" class="mt-3">
      <iframe
        v-if="is_previewable"
        :src="preview_url"
        width="100%"
        height="500px"
      ></iframe>
      <div v-else>
        <p>Preview unavailable for this file type.</p>
      </div>
    </div>
           </div>
          <div class="modal-footer border-0 p-2 d-flex justify-content-end mb-2">
              <button @click="submit_payment_proof" type="button" class="btn btn-primary-dark btn-sm text-xxs shadow-sm">Upload</button>
          </div>
      </div>
  </div>
</div>
</teleport>

<!-- Preview Invoice Modal -->
 <teleport to="body">
<div class="modal fade" id="preview_invoice" tabindex="-1" aria-labelledby="preview_invoice_modal_label" aria-hidden="true">
  <div class="modal-dialog modal-xl modal-dialog-centered">
    <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
      <div class="modal-header border-bottom-0 cute-header shadow-lg">
        <p class="modal-title text-white text-xxs" id="preview_invoice_modal_label">Quote Preview</p>
        <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body p-0">
        <div class="ratio ratio-4x3">
          <iframe
            v-if="preview_url"
            :src="preview_url"
            allowfullscreen
          ></iframe>
          <div v-else class="d-flex align-items-center justify-content-center w-100 h-100">
            No preview available.
          </div>
        </div>
      </div>

        <div class="modal-footer border-0 p-2 d-flex justify-content-end mb-2">
          <button
            class="btn btn-primary-dark"
            @click="approve_quote(selectedInvoice.id)"
            data-bs-dismiss="modal"
            :disabled="approve_loading"
          >
            <span v-if="!approve_loading">Approve</span>
            <span v-else class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          </button>

        </div>

    </div>
  </div>
</div>
</teleport>

<teleport to="body">
<div class="modal fade" id="reject_quote_modal" tabindex="-1" aria-labelledby="reject_quote_label" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content bg-white rounded-3 p-0 shadow-lg">

      <!-- Modal Header -->
      <div class="modal-header border-bottom-0 cute-header shadow-lg">
        <h5 class="modal-title text-white text-xxs" id="reject_quote_label">Reject Quote</h5>
        <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>

      <!-- Modal Body -->
      <div class="modal-body">
        <p class="mb-2 text-xs">Please provide a reason for rejecting this quote:</p>
        <textarea
          v-model="rejection_reason"
          class="form-control"
          rows="4"
          placeholder="Enter reason..."
        ></textarea>
      </div>

      <!-- Modal Footer -->
      <div class="modal-footer">
        <button
          class="btn btn-primary-dark btn-sm text-xxs shadow-sm"
          @click="submit_rejection"
          :disabled="reject_loading || !rejection_reason.trim()"
          data-bs-dismiss="modal"
        >
          <span v-if="!reject_loading">Reject Quote</span>
          <span v-else class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        </button>
      </div>

    </div>
  </div>
</div>
</teleport>



